var map = {
	"./cnn-money-x2.png": 2069,
	"./cnn-money.png": 2283,
	"./economist-x2.png": 2070,
	"./economist.png": 2284,
	"./mashable-x2.png": 2071,
	"./mashable.png": 2285,
	"./tech-crunch-x2.png": 2072,
	"./tech-crunch.png": 2286,
	"./thenewyorker-x2.png": 2073,
	"./thenewyorker.png": 2287,
	"./thrillist-x2.png": 2074,
	"./thrillist.png": 2288,
	"./time-x2.png": 2075,
	"./time.png": 2289,
	"./usa-today-x2.png": 2076,
	"./usa-today.png": 2290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2282;